import { render, staticRenderFns } from "./WidgetAgenciesBookingResume.vue?vue&type=template&id=673da4e6"
import script from "./WidgetAgenciesBookingResume.vue?vue&type=script&lang=js"
export * from "./WidgetAgenciesBookingResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports